import { toastr } from 'react-redux-toastr';

const unexpectedServerError = () => {
  toastr.error('Server error', 'Server not responding. Try again later.');
};

export { unexpectedServerError };
